var quotes = require('./ExistingOrders/quotes');
var orders = require('./ExistingOrders/orders');


var ExistingOrders = function () {
    var self = this;

    this.quotes = quotes;
    this.orders = orders;

    this.focused = ko.observable('').extend({
        notify: 'always'
    });

    this.clean = function () {
        self.quotes.clean();
        self.orders.clean();
    };

    this.refresh = function () {
        self.quotes.refresh();
        self.orders.refresh();
    };

    this.onHide = function () {
        self.quotes.cleanSearchForm();
        self.orders.cleanSearchForm();

        self.focused('');
    };

    this.init = function (quotes, orders) {
        self.quotes.init(quotes);
        self.orders.init(orders);

        self.focused('title');
    };
};

module.exports = ExistingOrders;


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ExistingOrdersPage.js
// module id = 21
// module chunks = 0